import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import signInClient from "../auth";
import p4lLogo from "../assets/logo/PfL Logo no words 2023-11-21-01.png";
import Button from "../componentLibrary/Button";

interface ComponentProps {
  error: string;
  setError: (error: string) => void;
}

const CodeFlowComponent = ({ setError }: ComponentProps) => {
  const { user } = useAuth();
  const username = user?.name;
  const [email, setEmail] = useState(username || "");

  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleSendVerificationCode = async () => {
    setIsLoading(true);
    if (email.trim() === "") {
      setError("Please provide a valid username.");
      setIsLoading(false);
      return;
    }

    try {
      await signInClient.post("/forgot-password", { email });
      navigate("/verification-code");
    } catch {
      setError("Error sending verification code.");
    }
    setIsLoading(false);
  };

  return (
    <div className="space-y-2">
      <TextField
        label="Username"
        variant="outlined"
        fullWidth
        type="username"
        name="username"
        value={email}
        onChange={(e) => {
          setError("");
          setEmail(e.target.value);
        }}
      />
      <Button
        className="w-full"
        onClick={handleSendVerificationCode}
        loading={isLoading}
      >
        Send Verification Code
      </Button>
    </div>
  );
};

const ConfirmIdentity = () => {
  const [error, setError] = useState("");

  return (
    <div className="flex flex-col mx-auto w-80 mt-24 mb-12 space-y-4">
      <div className="flex flex-col items-center">
        <img
          src={p4lLogo}
          alt="Psych For Life logo"
          className="w-32 h-32 mb-2"
        />
        <p className="text-gray-700 text-3xl">Psych For Life&reg;</p>
      </div>
      <p className="text-gray-700 text-2xl">Confirm Identity</p>
      <p>Enter username to receive a verification code</p>
      <CodeFlowComponent error={error} setError={setError} />
      {error && <p className="text-red-500">{error}</p>}
    </div>
  );
};

export default ConfirmIdentity;
